import 'toastify-js/src/toastify.css';

window.$ = window.jQuery = require('jquery');

window.currentLocale = function () {
    return window.$('meta[name="locale"]').attr('content');
};

require('./header/header.js');
require('./utils/recaptchaV3.js');
require('./components/tabs');
require('./components/accordion');

const { openSocial } = require('./utils/openSocial.js');
const { routeLocale } = require('./utils/routeLocale.js');

window.openSocial = openSocial;

window.routeLocale = routeLocale;
